<template>
  <div class="country-filter-country-info">
    <div class="country-info">
      <img class="country-flag" :src="countryInfo.national_flag_img" alt="">
      <div class="country-name">{{ countryInfo.country }}</div>
      <div class="icon-box">
        <div class="icon"></div>
      </div>
    </div>
    <div class="country-search-box" @click.stop="() => {}">
      <div class="search-input-wrap">
        <div class="search-input-box">
          <input class="search-input" v-model="searchInput" @focus="searchInputFocus" @input="changeSearchInput" type="text" placeholder="搜索国家/地区" />
          <img class="search-icon" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/country/icon-search.png" />
        </div>
        <div class="search-input-result" >
          <transition name="country-list" v-show="searchInput">
            <div class="result-country-list" v-if="searchInput">
              <div class="result-country-null-item" v-if="!countryResult.length">暂无结果</div>
              <template v-else>
                <div class="result-country-item" v-for="(item, index) in countryResult" :key="index" @click="gotoCountryPage(item)">
                  <div class="country-item-name">{{item.country}}</div>
                  <div class="country-item-type">{{item.visa_type_list.join(' ')}}</div>
                </div>
              </template>
            </div>
          </transition>

          <div v-show="!searchInput" class="country-table-box">
            <country-table-letter-inner :country-list="countryList" @click-country="searchInputBlur"></country-table-letter-inner>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from '../../../libs/http';
import CountryTableLetterInner from '../../../components/common/country-table-letter-inner';

export default {
  components: {
    CountryTableLetterInner,
  },
  props: {
    countryInfo: Object,
  },
  data() {
    return {
      countryList: [],
      searchInput: '',
      showSearchResult: false,
      countryResult: [],
    };
  },
  computed: {
    searchPinyinFormat() {
      return this.countryList.map(item => ({
        pinyin_shortcut: PinyinHelper.convertToPinyinString(item.country, '', PinyinFormat.FIRST_LETTER),
        ...item,
        country_pinyin_shortcut: PinyinHelper.convertToPinyinString(item.country, '', PinyinFormat.FIRST_LETTER),
        country_alias_pinyin_shortcut: item.country_alias ? PinyinHelper.convertToPinyinString(item.country_alias, '', PinyinFormat.FIRST_LETTER) : '',
        country_alias_pinyin: item.country_alias ? PinyinHelper.convertToPinyinString(item.country_alias, '', PinyinFormat.WITHOUT_TONE) : '',
        country_alias: item.country_alias || '',
      }));
    },
  },
  created() {
    this.getCountryList();
    document.body.addEventListener('click', this.searchInputBlur);
  },
  destroyed() {
    document.body.removeEventListener('click', this.searchInputBlur);
  },
  methods: {
    getCountryList() {
      Http.post('/sys/visa_country_available_brief_query').then((data) => {
        this.countryList = data.result;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    changeSearchInput() {
      let query = this.searchInput;
      if (query) {
        // 隐藏国家表
        this.showCountryTable = false;

        query = query.toLowerCase();

        this.countryResult = this.searchPinyinFormat.filter(v => v.cn_country.indexOf(query) > -1 ||
          v.en_country.toLowerCase().indexOf(query) > -1 ||
          v.country.indexOf(query) > -1 ||
          v.country_pinyin_shortcut.indexOf(query) > -1 ||
          v.country_alias_pinyin_shortcut.indexOf(query) > -1 ||
          v.country_alias_pinyin.indexOf(query) > -1 ||
          v.country_alias.indexOf(query) > -1,
        );
      } else {
        this.countryResult = [];
        // 展示国家表
        this.showCountryTable = true;
      }
    },


    searchInputFocus() {
      this.showSearchResult = true;
    },
    searchInputBlur() {
      this.searchInput = '';
      this.showSearchResult = false;
    },

    // 跳转国家
    gotoCountryPage(countryInfo) {
      this.$router.push({ name: 'country', params: { id: countryInfo.id || countryInfo.visa_country_id }, query: JSON.parse(JSON.stringify(this.$route.query)) });
      this.searchInputBlur();
    },
  },
};
</script>

<style lang="less" scoped>
.country-filter-country-info{
  flex-shrink: 0;
  width: 224px;
  padding-right: 12px;
  position: relative;
  height: 100%;
  &::after {
    content: "";
    width: 1px;
    height: 32px;
    background: #E9EEF2;
    border-radius: 1px;
    position: absolute;
    right: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .country-info{
    flex-shrink: 0;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 8px;
    position: relative;
    &::after{
      content: "";
      width: 100%;
      height: 4px;
      background: #fff;
      position: absolute;
      bottom: -2px;
      left: 0;
      z-index: 11;
    }
    
    .country-flag{
      flex-shrink: 0;
      height: 16px;
      margin-right: 12px;
      border: 1px solid #f0f0f0;
    }
    .country-name{
      color: #2F333D;
      font-size: 20px;
      font-weight: 600;
      flex-grow: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .icon-box{
      margin-left: 4px;
      flex-shrink: 0;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/country/icon-search.png) no-repeat center / 30px 29px;
    }
  }
  .country-search-box{
    display: none;
    position: absolute;
    top: 100%;
    background: #fff;
    box-shadow: 0px 8px 12px 0px rgba(57,61,70,0.13);
    width: 642px;
    z-index: 10;
    padding: 8px;
    border: 1px solid rgba(201, 205, 209, 0.25);
    .search-input-wrap{
      position: relative;
      .search-input-box{
        width: 100%;
        position: relative;
        .search-input{
          width: 100%;
          height: 44px;
          padding: 0 60px 0 16px;
          color: #2F333D;
          outline: none;
          border: 1px solid #C9CDD1;
          font-size: 18px;
          border-radius:2px;
          &::placeholder{
            color: #91999F;
          }
        }
        .search-icon{
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          width: 30px;
          height: 29px;
        }
      }
      .search-input-result{
        margin-top: 8px;
        width: 100%;
        z-index: 25;
        .result-country-list{
          width: 100%;
          border-radius:2px;
          font-size: 18px;
          max-height: 300px;
          overflow: auto;
          .result-country-null-item{
            width: 100%;
            height: 50px;
            color: #91999F;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .result-country-item{
            width: 100%;
            height: 50px;
            color: #91999F;
            display: flex;
            align-items: center;
            cursor: pointer;
            border-radius: 2px;
            &:hover{
              background: #F3F6F9;
              .country-item-name{
                color: #599FFF;
              }
            }
            .country-item-name{
              flex-shrink: 0;
              padding: 0 16px;
              color: #2F333D;
              font-weight: 600;
            }
            .country-item-type{
              flex-grow: 1;
              margin-left: 24px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
        .country-table-box{
          /deep/ .country-table-data{
            box-shadow: none;
          }
        }
      }
    }
  }
  &:hover{
    .country-info{
      box-shadow: 0px 8px 12px 0px rgba(57,61,70,0.13);
      border: 1px solid rgba(201, 205, 209, 0.25);
      .icon-box{
        background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/country/icon-down-blue.png) no-repeat center / 24px 24px;
      }
    }
    .country-search-box{
      display: block;
    }
  }
}

.country-list-enter-active {
  transition: all 0.15s ease;
  opacity: 0;
}
.country-list-enter-to{
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/country/components/country-top-country-info.vue